import {MaxxBelek} from "./MaxxBelek";
import {VoyageBelek} from "./VoyageBelek";
import {MaxxBelekSports} from "@/utils/MaxxBelekSports";

export const _HOTEL = {
    MaxxBelek,
    VoyageBelek,
    MaxxBelekSports
}
